import { Auth } from '@justgiving/auth';
import { GraphQLClient } from 'graphql-request';
import config from '../config';

export const createGraphQlClient = (auth?: Auth) => {
  return new GraphQLClient(config.GRAPHQL_URL, {
    credentials: 'include',
    headers: {
      'apollographql-client-name': 'JG.Charity.GivingCheckout',
    },
    fetch: async (uri: string, options: RequestInit) => {
      if (auth?.isUserLoggedIn()) {
        await auth?.refreshAccessTokenIfExpired();
      }
      return fetch(uri, options);
    },
  });
};
